import importJs from '@/util/importJs.js';
import weixin from './weixin';
const captchaJs = 'https://turing.captcha.qcloud.com/TCaptcha.js';
const captchaAppId = process.env.VUE_APP_CAPTCHA_APPID

export default {
    extends: weixin,
    mounted() {
        var me = this;
        if (!me.isWxWorkClient() && !me.isWeixinClient()) {
            me.loadCaptcha();
        }
    },
    methods: {
        onWxEnabled() {
            const me = this
            // 小程序环境里面访问此h5应用时，不能加载外部业务域名下的资源
            me.isMiniProgram().then(function(res){
                if (!res) {
                    me.loadCaptcha();
                }
            })
        },
        loadCaptcha() {
            const me = this
            importJs(captchaJs, function(){
                me.$captcha = new window.TencentCaptcha(captchaAppId, res => {
                    me.$bus.$emit('getTicket', res)
                }, {});
            })
        }
    }
}